<template>
    <div :class="{
                'hd-update p-0': true,
                'position-relative': $detect == 'web',
                'hd-update-mobile': $detect == 'mobile'
            }">
        <div>
            <div class="title border-bottom border-primary">
                <div class="d-flex justify-content-between">
                    <div :class="{
                        'py-10px px-3': $detect == 'web',
                        'pt-1 pb-2': $detect == 'mobile'
                    }">Thông tin câu hỏi</div>
                    <div class="btn-update" role="button" @click="activeUpdate = true" v-if="hoidap.update_status">
                        <i class="icon ion-md-create mr-2"></i>Chỉnh sửa
                    </div>
                </div>
            </div>
            <div :class="{
                    'body': true,
                    'p-3': $detect == 'web'
                }">
                <div class="title-faq">
                    <p class="mb-0 fw-600">Tiêu đề câu hỏi:</p>
                    <p class="mb-0">{{ hoidap.name }}</p>
                </div>
                <div class="category-faq mt-3">
                    <p class="mb-0 fw-600">Danh mục:</p>
                    <p class="mb-0">{{ hoidap.category ? hoidap.category.name : ''}}</p>
                </div>
                <div class="des-faq mt-3">
                    <p class="mb-0 fw-600">Nội dung:</p>
                    <p class="mb-0 mt-2" v-html="hoidap.description"></p>
                </div>
            </div>
        </div>
        <div class="hd-edit position-absolute" v-if="activeUpdate">
            <div class="content-edit bg-white">
                <div class="title-edit py-10px px-3 border-bottom border-primary">
                    <span>Chỉnh sửa câu hỏi</span>
                    <div class="close" role="button" @click="cancelUpdate()">
                        <i class="icon ion-md-close"></i>
                    </div>
                </div>
                <div class="form-edit">
                    <div class="body p-3">
                        <div class="title">
                            <p class="mb-1">Tiêu đề</p>
                            <input placeholder="Nhập tiêu đề" :class="{
                                'px-10px input-titile rounded w-100': true,
                                'border-danger input-validate': validateForm.name != null,
                                }" v-model="form.name"/>
                            <div class="validate-form text-danger fs-12px ml-1 mt-1" v-if="validateForm.name != null">
                                {{ validateForm.name }}
                            </div>
                        </div>
                        <div class="hd-list-category mt-3">
                            <p class="mb-1">Danh mục</p>
                            <ldc-dropdown
                                trigger="click"
                                :action-close="true"
                                :active-dropdown.sync="activeCategory">
                                <button role="button" class="fs-14px dropdown-category px-3 btn-block text-left">
                                    {{ nameCategory ? nameCategory : hoidap.category.name  }}
                                </button>
                                <ldc-dropdown-menu>
                                    <div class="category">
                                        <div class="search-category">
                                            <div class="input-icon mb-2">
                                                <input type="text" placeholder="Nhập danh mục cần tìm" v-model="keyword"/>
                                                <i class="icon ion-ios-search" role="button" @click="getCategorySearch()"></i>
                                            </div>
                                            <div class="line-loading" v-if="vloading"></div>
                                            <div class="btn-search-category pl-10px text-primary fs-14px"
                                                role="button" v-show="status_category == 2 && vloading == false" @click="status_category = 1">
                                                Danh sách danh mục
                                            </div>
                                            <div class="btn-search-category pl-10px text-primary fs-14px"
                                                role="button" v-show="status_category == 1 && categories_search != ''" @click="status_category = 2">
                                                Danh sách tìm kiếm danh mục
                                            </div>
                                            <div class="back-category pl-10px text-danger" role="button"
                                                v-show="id_cat.length > 0 && status_category == 1" @click="goBack()">
                                                <i class="icon ion-md-arrow-back mr-2 fs-18px"></i>Quay lại
                                            </div>
                                        </div>
                                        <div class="list-category vg-scrollbar" v-show="status_category == 1">
                                            <div class="list-item p-10px"
                                                role="button"
                                                v-for="(category, index) in categories" :key="index"
                                                @click="category.has_child ? getChild(category) : closeCategory(category)">
                                                <span class="name fs-14px">{{ category.name }}</span>
                                                <span class="icon float-right" v-if="category.has_child == true">
                                                    <i class="icon ion-ios-arrow-forward fs-16px"></i>
                                                </span>
                                            </div>
                                        </div>
                                        <div :class="{
                                                    'list-category vg-scrollbar': true,
                                                    'unset-height': noCategory,
                                                }" v-if="status_category == 2 && vloading == false">
                                            <div class="list-item p-10px"
                                                role="button"
                                                v-for="(category, index) in categories_search" :key="index"
                                                @click="closeCategory(category)">
                                                <span class="name fs-14px">{{ category.name }}</span>
                                            </div>
                                            <div class="text-center my-4" v-show="noCategory">
                                                Không có danh mục
                                            </div>
                                        </div>
                                        <div class="searching my-4 text-center" v-if="vloading">
                                            Đang tìm kiếm...
                                        </div>
                                    </div>
                                </ldc-dropdown-menu>
                            </ldc-dropdown>
                        </div>
                        <div class="content mt-3">
                            <p class="mb-1">Nội dung</p>
                            <editor :content.sync="form.description"/>
                        </div>
                        <div :class="{
                                'text-center mt-3': true,
                                'mb-3': $detect == 'mobile'
                            }">
                            <button class="btn btn-secondary px-4 py-1 mr-2" @click="cancelUpdate()">Huỷ</button>
                            <button class="btn btn-primary px-4 py-1 ml-2" @click="updateFaq()">Sửa câu hỏi</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    components: {
        editor: () => import('@/components/editor/index'),
    },
    data() {
        return {
            hoidap: [],
            activeUpdate: false,
            status_category: 1,
            categories : [],
            id_cat: [],
            nameCategory: '',
            activeCategory: false,
            keyword: '',
            categories_search : [],
            vloading: false,
            noCategory: false,
            validateForm: [],
            form: {
                name: '',
                category_id: '',
                description: '',
            }
        }
    },
    watch: {
        keyword(val){
            if(val.length >= 3){
                this.status_category = 2;
                this.vloading = true;
                if(this.timeOutStatus) clearTimeout(this.timeOutStatus);
                this.timeOutStatus = setTimeout(() => {
                    this.getCategorySearch();
                }, 300);
            }
        }
    },
    created() {
        this.getHoidap();
        this.getCategory();
    },
    methods: {
        getHoidap() {
            apiGet('/v2/profile/hoidap/' + this.$route.params.id).then((res) => {
                this.hoidap = res.data;
                this.form.name = this.hoidap.name;
                this.form.description = this.hoidap.description;
                this.form.category_id = this.hoidap.category.id;
            }).catch((err) =>{
                if (err.status == 410) {
                    this.$message({
                        message: err.data.message,
                        type: 'error',
                        center: true,
                    });
                    this.$router.push({
                        name: 'hoidap'
                    })
                }
            })
        },
        async getCategory(parent_id = 0){
            await apiGet('/v1/categories', {
                module: 'hoidap',
                parent_id: parent_id,
            }).then(res => {
                this.categories = res.data;
            });
        },
        async goBack() {
            this.vloading = true;
            let parent_id = 0;
            if(this.id_cat.length > 1) {
                parent_id = this.id_cat[this.id_cat.length -2];
            }
            await this.getCategory(parent_id);
            this.id_cat.splice(this.id_cat.length - 1, 1);
            this.vloading = false;
        },
        async getChild(category) {
            if(this.vloading) return;
            this.vloading = true;
            await this.getCategory(category.id);
            this.id_cat.push(category.id);
            this.vloading = false;
        },
        closeCategory(category) {
            this.nameCategory =  category.name;
            this.activeCategory = false;
            this.form.category_id = category.id;
        },
        async getCategorySearch() {
            if(this.keyword.length >= 3){
                this.vloading = true;
                await apiGet('/v2/category/search', {
                    keyword: this.keyword
                }).then(res => {
                    this.categories_search = res.data;
                    if(this.categories_search.length == 0) {
                        this.noCategory = true;
                    } else {
                        this.noCategory = false;
                    }
                });
                this.vloading = false;
            }
        },
        updateFaq() {
            apiPut('/v2/profile/hoidap/' + this.$route.params.id, {
                name: this.form.name,
                category_id: this.form.category_id,
                description: this.form.description
            }).then(res => {
                if(res.success == 1) {
                    this.$message({
                        message: 'Sửa câu hỏi thành công',
                        type: 'success',
                        center: true,
                    });
                    this.activeUpdate = false;
                    this.hoidap.name = res.data.title;
                    this.hoidap.category.name = res.data.category.name;
                    this.hoidap.description = res.data.description;
                } else {
                    this.$message({
                        message: 'Sửa câu hỏi không thành công. Vui lòng kiểm tra lại câu hỏi',
                        type: 'error',
                        center: true,
                    });
                }
            }).catch(err =>{
                if(err.status == 422) {
                    if (err.message) {
                        this.$message({
                            message: err.message,
                            type: 'error',
                            center: true,
                        });
                        this.validateForm = err.data;
                    }
                    let txtEror = '';
                    for (var key in err.data) {
                        // if (typeof err.data[key] == 'string')
                            txtEror += err.data[key] + ', ';
                    }
                    if (txtEror) {
                        this.$message({
                            type: 'error',
                            message: txtEror.trim(', '),
                            center: true,
                        }); 
                    }
                }
            })
        },
        cancelUpdate() {
            this.activeUpdate = false;
            this.nameCategory = this.hoidap.category.name;
            this.form.category_id = this.hoidap.category.id;
        }
    }
}
</script>

<style lang="scss">
    .hd-update {
        min-height: calc(100vh - 115px);
        .title {
            .btn-update {
                color:#007bff;
                font-size: 14px;
                padding: 11px 16px;
                &:hover {
                    text-decoration: underline;
                }
            }
        }
        .hd-edit {
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(240, 245, 249, 0.8);
            .content-edit {
                box-shadow: 0 4px 25px 0 rgba(0, 0, 0, 0.1);
                border-radius: 4px;
                .body {
                    .input-titile {
                        height: 40px;
                        border: 1px solid rgba(0, 0, 0, 0.2);
                        &:focus {
                            outline: none !important;
                        }
                    }
                    .hd-list-category {
                        .dropdown-category {
                            height: 40px;
                            background: #fff;
                            border: 1px solid rgba(0, 0, 0, 0.2);
                            border-radius: 4px;
                        }
                        .input-icon {
                            position: relative;
                            input {
                                width: 100%;
                                background-color: white;
                                border-radius: 4px;
                                border: 1px solid rgba(0, 0, 0, 0.1);
                                padding: 0 40px 0 10px;
                                transition: border 0.2s ease-in;
                                height: 40px;
                                &:focus {
                                    border-color: #2979ff;
                                    box-shadow: none !important;
                                    outline: none !important;
                                }
                            }
                            i {
                                color: #000;
                                font-size: 20px;
                                position: absolute;
                                right: 14px;
                                top: 50%;
                                transform: translateY(-50%);
                            }
                        }
                        .list-category {
                            height: 350px;
                            overflow-y: auto;
                        }
                        .unset-height {
                            height: unset !important;
                        }
                    }
                    .text-placeholder-category {
                        color: #777;
                    }
                    .input-validate {
                        &::placeholder {
                            color: #dc3545;
                        }
                    }
                    .line-loading {
                        width: 100%;
                        height: 3px;
                        position: relative;
                        margin: -8px auto 10px;
                        &:before {
                            content: "";
                            position: absolute;
                            right: auto;
                            left: 0;
                            height: 100%;
                            background-color: #0c81f6;
                            animation: lineLoading 1s forwards infinite linear;
                        }
                    }
                    @keyframes lineLoading {
                        0% {
                            right: 100%;
                        }

                        50% {
                            right: 0;
                            left: 0;
                        }

                        100% {
                            right: 0;
                            left: 100%;
                        }
                    }
                }
            }
        }
    }
    .hd-update-mobile {
        .btn-update {
            padding: 5px 0 8px !important;
        }
        .title-faq {
            margin-top: 10px;
        }
        .form-edit {
            .body {
                padding: 10px !important;
            }
        }
        .title-edit {
            background-color: #007bff;
            color: #fff;
            padding: 10px !important;
            .close {
                color: #fff;
            }
        }
    }
</style>
